import React, { useState } from 'react';
import { Form } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import Swal from 'sweetalert2';
import { ProfileFormComponent } from './ProfileFormComponent';
import { delivererClient } from '../../../../../core-module/services/deliverer/DelivererClient';
import { Customer } from '../../../../../core-module/services/logistics/types';
import { getDefaultPortion } from '../../../../../core-module/helpers/defaultPortionHelpers';
import { v4 } from 'uuid';

interface OwnProps {
  readonly customer: Customer;
  readonly onHideClick: () => void;
}

interface FormValues {
  route_remarks: string;
  meal_overview_amount: number;
  default_portion?: number;
}

type Props = OwnProps & FormComponentProps<FormValues>;

const ProfileFormContainer = (props: Props) => {
  const { form, customer, onHideClick } = props;
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    form.validateFields((errors, values) => {
      if (errors) {
        return;
      }

      setIsSaving(true);
      const idempotencyKey = v4();

      delivererClient
        .updateCustomerInformation(customer.customer_id, idempotencyKey, {
          defaultPortie: getDefaultPortion(values.default_portion)?.name ?? null,
          routelijstOpmerking: values.route_remarks,
          papierenWeekMenuAmount: values.meal_overview_amount
        })
        .then(() => {
          Swal({
            type: 'success',
            confirmButtonText: 'Ok',
            title: 'Gegevens opgeslagen',
            text: 'Het kan even duren voor de wijzigingen zichtbaar worden'
          });
          onHideClick();
        })
        .catch((err) => {
          Swal({
            type: 'error',
            confirmButtonText: 'Ok',
            title: 'Er is een fout opgetreden',
            text: err.message
          });
          setIsSaving(false);
        });
    });
  };

  return (
    <ProfileFormComponent
      form={form}
      isSaving={isSaving}
      customer={customer}
      onSaveClick={handleSave}
      onHideClick={onHideClick}
    />
  );
};

export default Form.create<Props>()(ProfileFormContainer);
